import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69fb10e9"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"margin-top":"8px","display":"flex","flex-direction":"column"}
}
const _hoisted_2 = ["src"]

import {computed, onUnmounted, ref} from 'vue';
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer"
import {ScForm} from "@/models/ScForm";
import {UploadChangeParam, UploadProps} from "ant-design-vue";
import {VideoFieldType} from "@/components/business/crud/interface/FieldType";
import {useCosUploader} from "@/components/business/crud/widgets/impl/component/cosUploader";



import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: "normal", show: "normal"}
});

export default /*#__PURE__*/_defineComponent({
  __name: 'VideoForm',
  props: {
    propName: {},
    widget: {},
    info: {}
  },
  setup(__props: any) {

const props = __props;

const data = ScForm.useFormData();
const cosUploader = useCosUploader();

const uploadList = ref<Exclude<UploadProps['fileList'], undefined>>([]);
const previewVisible = ref(false);
const previewImage = ref('');
const previewTitle = ref('');

const handleCancel = () => {
  previewVisible.value = false;
  previewTitle.value = '';
};
const handlePreview = async (file: any) => {
  previewImage.value = file.url;
  previewVisible.value = true;
  previewTitle.value =
      file.name || file.url.substring(file.url.lastIndexOf('/') + 1);
};

const fileList = computed(() => {
  let res: Exclude<UploadProps['fileList'], undefined> = [];
  if (data.value[props.propName]) {
    if (typeof data.value[props.propName] === 'string') {
      res.push({
        uid: data.value[props.propName],
        name: data.value[props.propName],
        status: 'done',
        url: data.value[props.propName],
      });
    } else {
      res = data.value[props.propName].map((item: string) => {
        return {
          uid: item,
          name: item,
          status: 'done',
          url: item,
        };
      });
    }
  }
  return res.concat(...uploadList.value);
})

function onChange(info: UploadChangeParam) {
  uploadList.value = info.fileList.filter((file) => file.status !== 'done');
  const file = info.file;
  if (file.status === 'removed') {
    if (props.widget.multi) {
      if (data.value[props.propName]) {
        if (!(data.value[props.propName] instanceof Array)) {
          data.value[props.propName] = [data.value[props.propName]];
        }
        data.value[props.propName] = data.value[props.propName].filter(
            (id: string) => id !== file.uid
        );
      }
    } else {
      data.value[props.propName] = null;
    }
  } else if (file.status === 'done') {
    if (props.widget.multi) {
      if (!data.value[props.propName]) {
        data.value[props.propName] = [];
      }
      if (!(data.value[props.propName] instanceof Array)) {
        data.value[props.propName] = [data.value[props.propName]];
      }
      data.value[props.propName].push(file.response.path);
    } else {
      data.value[props.propName] = file.response.path;
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_a_upload, {
      disabled: _ctx.info.status !== 'edit',
      "file-list": fileList.value,
      accept: "video/*",
      "list-type": "picture-card",
      onChange: onChange,
      onPreview: handlePreview,
      multiple: _ctx.widget.multi,
      "custom-request": _unref(cosUploader),
      "is-image-url": () => false
    }, {
      default: _withCtx(() => [
        (_ctx.info.status === 'edit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createTextVNode(" 上传 "),
              _createElementVNode("span", null, _toDisplayString(_ctx.info.desc), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["disabled", "file-list", "multiple", "custom-request"]),
    (previewVisible.value)
      ? (_openBlock(), _createBlock(_component_a_modal, {
          key: 0,
          footer: null,
          title: previewTitle.value,
          visible: true,
          onCancel: handleCancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("video", {
              src: previewImage.value,
              controls: "",
              style: {"width":"100%"}
            }, null, 8, _hoisted_2)
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})